import React from "react";
import { Platform, ScrollView, Text } from "react-native";
import tw from "twrnc";

import { colors, radius } from "./theme";

// Code to copy (embed codes): monospaced, selectable, in a short scrolling
// box. Put a CopyButton under it.
const CodeBox = ({ code, maxHeight = 132, style }) => (
  <ScrollView
    style={[
      tw`mb-3`,
      {
        maxHeight,
        borderRadius: radius.control,
        backgroundColor: colors.surface,
        borderWidth: 1,
        borderColor: colors.border,
      },
      style,
    ]}
    contentContainerStyle={tw`p-3`}
    nestedScrollEnabled
  >
    <Text
      selectable
      style={[
        tw`text-[12px] leading-[18px]`,
        {
          color: colors.ink,
          fontFamily: Platform.OS === "ios" ? "Menlo" : "monospace",
        },
      ]}
    >
      {code}
    </Text>
  </ScrollView>
);

export default CodeBox;
